import { type SingleValue } from 'react-select'
import lodashThrottle from 'lodash/throttle'
import { snapshot } from 'valtio'
import lodashCloneDeep from 'lodash/cloneDeep'
import { type GlobalCustomerType } from '../../../../../../../shared/types/GlobalCustomerType'
import { formatFullName } from '../../../../../../../shared/utils/stringUtils'
import { virtualTerminalProxy } from '../../../virtualTerminalProxy'
import { resetCreditCardAddProxy } from '../../../../../../../shared/proxies/creditCardListProxy'
import { addToArray, removeFromArray } from '../../../../../../../shared/utils/arrayUtils'
import { customerListProxy } from '../../../../../../../shared/proxies/customerListProxy'
import {
  VirtualTerminalProxyFormFieldNamesEnum
} from '../../../../../../../shared/types/virtualTerminalProxyFormFieldNamesEnum'
import { clearServiceAddressInformationForCustomer, populateServiceAddressInfoFromCustomer } from '../utils'
import {
  type GlobalReactSelectOptionStringValueType
} from '../../../../../../../shared/types/GlobalReactSelectOptionStringValueType'
import { executeCustomerSectionCustomersSearch } from './executeCustomerSectionCustomersSearch'

export function buildOption (customer: GlobalCustomerType): GlobalReactSelectOptionStringValueType {
  return {
    label: `${formatFullName(customer.firstName, customer.lastName) ?? ''} (${customer.companyName})` ?? '',
    value: customer.id
  }
}
export function buildOptions (customers: readonly GlobalCustomerType[]): GlobalReactSelectOptionStringValueType[] {
  return customers.map(buildOption)
}

export async function loadOptions (search: string): Promise<GlobalReactSelectOptionStringValueType[]> {
  await executeCustomerSectionCustomersSearch(search)
  const { customers } = snapshot(customerListProxy)
  return buildOptions(customers)
}

export const throttledLoadOptions = lodashThrottle(loadOptions, 500, { trailing: true })

export async function handleChange (newValue: SingleValue<GlobalReactSelectOptionStringValueType>): Promise<void> {
  const customerId = newValue?.value ?? null
  const { customers } = snapshot(customerListProxy)
  const customer = customers.find(c => c.id === customerId)
  resetCreditCardAddProxy()
  virtualTerminalProxy.customerCard = null
  virtualTerminalProxy.achAccount = null
  if (customer) {
    virtualTerminalProxy.customer = lodashCloneDeep(customer)
    virtualTerminalProxy.form.dirty = addToArray(virtualTerminalProxy.form.dirty, 'customer')

    populateServiceAddressInfoFromCustomer()
  } else {
    virtualTerminalProxy.customer = null
    virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.Customer)

    clearServiceAddressInformationForCustomer()
  }
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.AchAccount)
  virtualTerminalProxy.form.dirty = removeFromArray(virtualTerminalProxy.form.dirty, VirtualTerminalProxyFormFieldNamesEnum.CustomerCard)
}
